import Reveal from "@/components/base/Reveal";

export default function CtaBand() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg border border-background-200/70 bg-secondary-50 px-6 py-12 text-center md:px-16 md:py-20">
            <span className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-accent-100/70" />
            <span className="pointer-events-none absolute -bottom-16 -left-10 h-52 w-52 rounded-full bg-primary-100/60" />

            <div className="relative">
              <span className="font-label text-xs uppercase tracking-[0.4em] text-primary-600">
                Start Anonymously
              </span>
              <h2 className="mx-auto mt-5 max-w-3xl font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
                有线索，就从一个安全的匿名入口开始
              </h2>
              <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
                无论您掌握何种线索，都可以通过我们的匿名投稿渠道分享。全程保护投稿人隐私，我们承诺严格保密，让您无忧爆料。
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="#channels"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  选择投稿渠道
                  <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-7 py-3.5 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
                >
                  先看看常见问题
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}